"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getDeep = void 0;

var getDeep = function getDeep(path, obj) {
  return path.split('.').reduce(function (context, cur) {
    return (context || {})[cur];
  }, obj);
};

exports.getDeep = getDeep;

var _default = function _default(path, scope) {
  return getDeep(path, scope) || getDeep(path, window) || {};
};

exports["default"] = _default;